import * as React from 'react';
import {LocalizerHelper} from "../../helpers/localizerHelper";
import {useNavigate, useParams} from "react-router";
import BottomSheetOrderRecap from "../bottom_order_recap/BottomOrderRecap";
import {BottomSheet} from "../bottom_sheet/BottomSheet";
import RestaurantHeader from "../restaurant/RestaurantHeader";
import {evaluateDitsMenuItemPriceV2} from "../../helpers/ditsMenuItemHelper";
import {formatPrice} from "../../helpers/formatHelper";
import Screen from '../screen';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import Menu from './Menu';
import "./index.scss"
import { MenuItemDetail } from '../menu_item/MenuItemDetail';
import { resetMenuItem } from '../../features/menuItem/menuItem.slice';

const MenuScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { restaurant: restaurantId, menu: menuId, link_alias: link_alias } = useParams<{ restaurant: string; menu: string, link_alias: string}>();
    const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);
    const session = useSelector((state: RootState) => state.session.session);
    const sessionMenuItems = useSelector((state: RootState) => state.session.menuItems);
    const menu = useSelector((state: RootState) => state.menu.menu);
    const bills = useSelector((state: RootState) => state.bill.bills);
    const menuItemSelected = useSelector((state: RootState) => state.menuItem.menuItemPath);

    const lastLinkAlias = (window.localStorage) ? (window.localStorage.getItem('chuzeat_last_alias_link') ?? '' ) : '';

    const closeMenuItemDetail = () => {
        dispatch(resetMenuItem());
    }

    const totalPrice = sessionMenuItems?.map((item) => evaluateDitsMenuItemPriceV2(item)).reduce((acc: number, price: number) => {
        return acc += (price * 1.0)
    }, 0) ?? 0;
    const _minimumOrderAmount = (restaurant?.minimum_external_order_amount ?? 0) * 1.0;
    const _isMajorThanMinimumPrice = totalPrice >= _minimumOrderAmount;
    const _canProceedWithOrder = sessionMenuItems.length > 0 && _isMajorThanMinimumPrice;

   const _proceedWithOrder = () => {
       if(!!session){
            const alias = link_alias ?? lastLinkAlias;
            const orderRecapPath = `/menu/${alias}/order-recap/${restaurantId}/${session.id}/${menuId}`;
            navigate(orderRecapPath);
       }
    }

    if(!!menu){
        return <Screen className="screen menu-quid-screen">
            <RestaurantHeader className='full-width block' showCart={true} onClickCart={_proceedWithOrder}/>
            <Menu onlyRead={false}></Menu>
            {!!menuItemSelected && 
                <BottomSheet className="bottom-sheet-detail" open={!!menuItemSelected} showClose={true} onClose={closeMenuItemDetail} radius={0}>
                    <MenuItemDetail  onlyRead={false} tableFinished={bills.length > 0}/>
                </BottomSheet>
            }
            { sessionMenuItems.length > 0 &&
                <BottomSheetOrderRecap 
                    nextLabel={LocalizerHelper.localized('proceed_with_order') ?? ""}
                    goToNext={_proceedWithOrder} 
                    disableAction={!_canProceedWithOrder}
                    disableLabel={_isMajorThanMinimumPrice ? null : `${LocalizerHelper.localized('minimum_order_amount')} ${formatPrice(_minimumOrderAmount)}`}
                    addDeliveryCosts = {false}/>
            }
            </Screen>
    }
    return null;
};

export default MenuScreen;
